import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { sectionBackgrounds, resolveGradient } from '../../../theme';
/**
 * TextBlock – rich text content. Supports label + gradient (same pattern as other CMS blocks).
 */
const TextBlock = ({ label, gradient, content = '', textColor, accentColor, secondaryColor, fontSize = '1rem', fontFamily, fontWeight = 400, lineHeight = 1.6, textAlign = 'left', paddingTop, paddingBottom, paddingLeft, paddingRight, marginTop, marginBottom, maxWidth, width, componentAlignment = 'left', }) => {
    const background = gradient
        ? resolveGradient(gradient, sectionBackgrounds.hero)
        : 'transparent';
    return (_jsx(Box, { component: "section", sx: {
            background,
            paddingTop: paddingTop || 3,
            paddingBottom: paddingBottom || 3,
            paddingLeft: paddingLeft || 0,
            paddingRight: paddingRight || 0,
            marginTop: marginTop || 0,
            marginBottom: marginBottom || 0,
            textAlign: componentAlignment,
        }, children: _jsxs(Box, { sx: { maxWidth: maxWidth || 800, mx: 'auto', px: 2 }, children: [label && (_jsx(Typography, { variant: "overline", sx: { display: 'block', mb: 2, color: 'text.secondary', letterSpacing: 1 }, children: label })), _jsx(Box, { sx: {
                        width: width || '100%',
                        color: textColor || 'text.primary',
                        fontFamily: fontFamily || undefined,
                        fontSize,
                        fontWeight: Number(fontWeight) || 400,
                        lineHeight: lineHeight ?? 1.6,
                        textAlign,
                        '& p': { mb: 2 },
                        '& h1, & h2, & h3, & h4, & h5, & h6': {
                            mb: 1.5,
                            mt: 2,
                            '&:first-of-type': { mt: 0 },
                        },
                        '& ul, & ol': { mb: 2, pl: 3 },
                        '& blockquote': {
                            borderLeft: '4px solid',
                            borderColor: accentColor || 'primary.main',
                            pl: 2,
                            ml: 0,
                            fontStyle: 'italic',
                            color: secondaryColor || 'text.secondary',
                        },
                    }, dangerouslySetInnerHTML: { __html: content || '<p>No content.</p>' } })] }) }));
};
export default TextBlock;
